/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';
import '../../oe-input/oe-input.js';
import '../../oe-ui-misc/oe-hbox.js';
/**
 * This element is used to display the customised paper input in the application
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-paper-input-demo.html
 * @summary Technical component
*/
const template = html`
    <style include="app-styles">
        oe-input {
            --paper-input-container: {
                font-size: 20px;
            }
            --paper-input-container-underline: {
                border-bottom-color: var(--border-color);
				border-bottom: 1px solid var(--border-color);
            }
            --paper-input-container-input-color: var(--font-color);
            --paper-input-container-input: {
               text-align: center;
            }

        }
		:dir(ltr) .marginRight {
			margin-right:3px;
		}
		:dir(rtl) .marginRight {
			margin-left:3px;
		}
        oe-input { 
            --paper-input-container-underline-disabled: {

                display: none;

            }
            background: #F4F5F7;
            border-radius: 5px; 
            --paper-input-container-underline-focus_-_display: none;
            --paper-input-container-underline-disabled: {
                    display: none;
                } 
             --oe-label-mixin_-_color:#828282; 
            }
    </style>
    
       <oe-hbox>	 
         <template is="dom-repeat" items="{{tmpvalue}}">
            <oe-input id="oe_input_{{item.key}}" auto-validate class="marginRight" style="width:40px; text-align: center" type="password" inputmode="numeric" pattern="[0-9]{1}"
            allowed-pattern="^[0-9]{1}" required={{required}} value="{{item.value}}" maxlength=1 on-keyup ="_onkeyup" on-keydown="_onkeydown"
            on-value-changed="tmpValueChanged" errorMessage="" disabled="{{isdisabled}}"></oe-input>
         </template>
    </oe-hbox>

    `;

Polymer({
    is: 'app-paper-input',
    _template: template,
    properties: {
        /*Value of String. This value should be set by parent element*/
        value: {
            type: String,
            notify: true,
            observer: 'valueChanged'
        },
        /*Temporary array of OTP value */
        tmpvalue: {
            type: Array,
            notify: true
        },
        /*Length of String. This should be set by parent element */
        inputlength: {
            type: Number,
            notify: true,
            observer: 'otpLenchanged'
        },
        /*Type of OTP. Number, String by default*/
        type: {
            type: String,
            notify: true
        },
        /*
        allowedPattern: {
            type: String,
            notify: true
        },*/
        /* Boolean to check whether input is required or not */
        required: {
            type: Boolean,
            value: false
        },

        /*Final Value which is computed from array. Parent element should use this for final value*/
        finalvalue: {
            type: String,
            notify: true
        },
        /* If the String is valid or not by length. This should be used by parent element to check before Submit*/
        isvalid: {
            type: Boolean,
            notify: true,
        },
        /* Property to disable the input */
        isdisabled: {
            type: Boolean,
            notify: true,
        }
    },
    attached: function () {
        setTimeout(function () {
            this.$$("#oe_input_0").focus();
        }.bind(this), 500);
    },
    /** 
     * Method to be executed when OTP length is changed
    **/
    otpLenchanged: function () {
        if (!this.value) {
            for (var i = 0; i < this.inputlength; i++) {
                var tmpObj = {
                    key: i,
                    value: ""
                }
                this.push('tmpvalue', tmpObj);
            }
        }
    },
    /** 
     * Observer for value. will called when value is changed. It will not work if the array('tempObj') is not created
     * @param {array} n 
    **/
    valueChanged: function (n) {
        this.tmpvalue = [];
        if (n.length > 0) {
            for (var i = 0; i < this.inputlength; i++) {
                if (n[i] === ' ' || n[i] === '1') { //This is to creat an array('tmpObj') with undefined values
                    var x = undefined;
                } else {
                    x = n[i];
                }
                var tmpObj = {
                    key: i,
                    value: x
                }
                this.push('tmpvalue', tmpObj);

            }
            // finalvalue for first time will be same as value
            this.finalvalue = this.value;
            //If the user doesnt change the any value then the OPT will be valid by default
            this.isvalid = true;
        }


    },
    /** 
     * this function will always calculate the final String value
    **/
    tmpValueChanged: function () {

        var tmpfinalvalue = "";
        for (var i in this.tmpvalue) {
            this.tmpvalue[i].value = this.shadowRoot.getElementById('oe_input_' + i).value;
            tmpfinalvalue = tmpfinalvalue + this.tmpvalue[i].value
        }
        this.finalvalue = tmpfinalvalue;

        //if the user changes the value of the input and if the value is not valid then set the property as invalid

        if (this.tmpvalue && (this.tmpvalue.length != this.finalvalue.length)) {
            this.isvalid = false;
        } else {
            this.isvalid = true;
        }

    },

    /*Keeeping this function as blank till component get tested for all the device.*/
    _onkeydown: function (e) {
        // When KeyDown event is fired, we are changing the model value to blank so that 
        // the existing key value will wipe out and new value will be displayed                
        // var model = e.model;
        //  model.set('item.value', "");
    	 //the function is added for the defect #406611 enable backspace
        var model=e.model
        if (model.item.value.length==0 && e.keyCode == 8) {
          var id=''
          var key=parseInt(model.item.key)
          var previousindex= key-1;
          if(key!=0){        
            id="oe_input_"+previousindex.toString();
      		  var preele=this.$$('#' + id);
            preele.focus();
          }
        }
    },
    /** 
     * this function will called when a key is pressed
     * @event
    **/
    _onkeyup: function (e) {
        /*Checking if the value entered is correct or not--Starts */
        var model = e.model;
        var currentIndex;
        //if the value of text input is blank then make the element invalid
        if (model.item.value == "") {
            currentIndex = parseInt(e.model.index);
            var currentElementStr = "oe_input_" + currentIndex.toString();
            var currentElement = this.$$('#' + currentElementStr);
            if (currentElement) {
                currentElement.invalid = true;
            }
        } else {
            //var value = model.item.value;
            //model.set('item.value', "");
            //model.set('item.value', e.key);                
        }

        /*Checking if the value entered is correct or not--End */


        var nextIndex = parseInt(e.model.index) + 1; //Changing the focus of to next element.

        var nextElementStr = "oe_input_" + nextIndex.toString();
        var nextElement = this.$$('#' + nextElementStr);
        var validNumber = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

        var previousIndex = nextIndex - 1;

        var previousElementStr = "oe_input_" + previousIndex.toString();
        var previousElement = this.$$('#' + previousElementStr);

        if (validNumber.includes(model.item.value)) {

            if (nextElement) {
                nextElement.focus(); //Adding click() since in browser element was focused but not cursor was not coming.

                nextElement.click();

            }
            // if (e.keyCode == 9 && e.shiftKey) {
            if (previousElement && (e.keyCode == 16 || e.keyCode == 9)) {
                previousElement.focus();

                previousElement.click();
            }

        }





        //if keyPressed is only number then focus should move to next element

        /*  if (e.keyCode >= 48 && e.keyCode <= 57) {
            if (nextElement) {
                nextElement.focus();
            }
            } */
        // Make blank values invalid for the previous element
        currentIndex = e.model.index;

        if (e.model.index > 0) {
            for (var i = currentIndex; i >= 0; i--) {
                if (this.tmpvalue[i].value == "") {
                    var blankElementStr = "oe_input_" + parseInt(i).toString();
                    var blankElement = this.$$('#' + blankElementStr);
                    blankElement.invalid = true;
                    //document.getElementById(blankElement).invalid = true;
                }
            }
        }

    }

});